import fish_0 from '../../../assets/images/fish-results/fish-result-0.svg';
import fish_1 from '../../../assets/images/fish-results/fish-result-1.svg';
import fish_2 from '../../../assets/images/fish-results/fish-result-2.svg';
import fish_3 from '../../../assets/images/fish-results/fish-result-3.svg';
import fish_4 from '../../../assets/images/fish-results/fish-result-4.svg';
import fish_5 from '../../../assets/images/fish-results/fish-result-5.svg';
import fish_6 from '../../../assets/images/fish-results/fish-result-6.svg';
import fish_7 from '../../../assets/images/fish-results/fish-result-7.svg';
import fish_8 from '../../../assets/images/fish-results/black_grouperl.svg';
import fish_9 from '../../../assets/images/fish-results/fish-result-8.svg';
import fish_10 from '../../../assets/images/fish-results/napoleon_fish.svg';
import fish_11 from '../../../assets/images/fish-results/lionfish.svg';
import fish_12 from '../../../assets/images/fish-results/fish-result-9.svg';
import fish_13 from '../../../assets/images/fish-results/sockeye_salmon.svg';
import fish_14 from '../../../assets/images/fish-results/fish-result-10.svg';
import fish_15 from '../../../assets/images/fish-results/pike.svg';
import fish_16 from '../../../assets/images/fish-results/fish-result-11.svg';
import fish_17 from '../../../assets/images/fish-results/fish-result-12.svg';
import fish_18 from '../../../assets/images/fish-results/catfish.svg';
import fish_19 from '../../../assets/images/fish-results/plaice_fish.svg';
import fish_20 from '../../../assets/images/fish-results/fish-result-20.svg';
import fish_21 from '../../../assets/images/fish-results/fish-result-21.svg';
import fish_shark from '../../../assets/images/fish-results/fish-result-shark.png';

export const FISH_IMAGES = [
  fish_0,
  fish_1,
  fish_2,
  fish_3,
  fish_4,
  fish_5,
  fish_6,
  fish_7,
  fish_8,
  fish_9,
  fish_10,
  fish_11,
  fish_12,
  fish_13,
  fish_14,
  fish_15,
  fish_16,
  fish_17,
  fish_18,
  fish_19,
  fish_20,
  fish_21,
  fish_shark,
];
